import { Component, OnInit, Injector, ChangeDetectionStrategy } from '@angular/core';
import { FormVerifyCustomerService } from '../services/form-verify-customer.service';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { LineStateActionService } from '../statemanagement/line-state-action.service';
import { ResponseStateRegistration } from '../models/verify.model';
import { ConcentService } from '../services/concent.service';
import { ActionStatus, ResponseStatus } from '../models/termAndCondition.model';
import { TermsAndConditionService } from '../services/terms-and-condition.service';
import { Identity } from '../models/customer.model';
import { SetIdentityAction } from '../statemanagement/action/identity.action';
import { BaseComponents } from 'src/app/base.component';
import { ReferenceService } from 'src/app/services/reference.service';
import { GetMaskingService } from 'src/app/adapters/getMasking.service';
@Component({
    selector: 'app-verify-register',
    templateUrl: './verify-register.component.html',
    styleUrls: ['./verify-register.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VerifyRegisterComponent extends BaseComponents implements OnInit {
  state = "pre-register";
  log_session_text: string = "verify-register";
  referenceUUID: string | null = null;
  constructor(
    protected injectorObj: Injector,
    private route: ActivatedRoute,
    private verifyCustomerService: FormVerifyCustomerService,
    private router: Router,
    private lineStateAction: LineStateActionService,
    private concentService: ConcentService,
    private termsAndConditionService: TermsAndConditionService,
    private referenceService:ReferenceService,
    private getMaskingService : GetMaskingService,
  ) { 
    super(injectorObj)
  }

  ngOnInit() {
    const funcName = 'ngOnInit';
    this.referenceUUID = this.referenceService.getReferenceUUID();
    this.log_session_text = `verify-register referenceUUID:[${this.referenceUUID}]`;
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    const channel = this.lineStateAction.channelStateInfo;
    if (channel) {
      this.logger.info(`${this.log_session_text} ${funcName} verifyRegister start`);
      this.verifyRegister(channel.application_channel_reference, channel.electronic_channel)
    }
  }

  async verifyRegister(chanelId, electronic) {
    // console.log('verify register line id: ' + lineId);
    const funcName = 'verifyRegister';
    const payload = {
      // channel_identity: lineId,
      application_channel_reference: chanelId,
      electronic_channel: electronic
    }
    this.logger.info(`${this.log_session_text} ${funcName} payload:${JSON.stringify(payload)}`);
    await this.verifyCustomerService.apiVerifyRegistration(payload).subscribe(
      async result => {
        console.log('verify', result);
        this.logger.info(`${this.log_session_text} ${funcName} response`);
        if (!result) return
        let channel = this.lineStateAction.channelStateInfo;
        this.logger.info(`${this.log_session_text} ${funcName} result.state_code:${result?.state_code}`);
        switch (result.state_code) {
          case (ResponseStateRegistration.REGISTERED_ALREADY): {
            this.state = 'register';
            this.logger.info(`${this.log_session_text} ${funcName} state:register channel.termsAndCondition.action:${channel?.termsAndCondition?.action}`);
            this.logger.info(`${this.log_session_text} ${funcName} state:register channel.termsAndCondition.status:${channel?.termsAndCondition?.status}`);
            if (channel && channel.termsAndCondition && channel.termsAndCondition.action == ActionStatus.ACCEPT && channel.termsAndCondition.status != ResponseStatus.COMPLETED) {
              this.logger.info(`${this.log_session_text} ${funcName} state:register termsAndCondition case accept callTermAndCondition start`);
              await this.callTermAndCondition(result["_1"]);
            } else if ((channel && channel.registerFlow.toLowerCase() == "short" && channel.comCode == "insure") || channel.registerFlow.toLowerCase() != "short") {
              this.logger.info(`${this.log_session_text} ${funcName} state:register registerFlow == short or comCode == insure || registerFlow != short callConcent start`);
              await this.callConcent(true);
            } else {
              this.logger.info(`${this.log_session_text} ${funcName} state:register case other goto completed`);
              this.router.navigate(['../completed'], { relativeTo: this.route });
            }
            break;
          }
          case (ResponseStateRegistration.NOT_REGISTERED): {
            this.logger.info(`${this.log_session_text} ${funcName} case not registered`);
            if (channel && channel.termsAndCondition && (channel.termsAndCondition.action != ActionStatus.ACCEPT)) {
              this.logger.info(`${this.log_session_text} ${funcName} case not registered goto page term-and-condition`);
              this.router.navigate(["./term-and-condition"], { relativeTo: this.route, queryParams: { "force": 1 } })
              return;
            }
            this.state = "not-register"
            if (channel.registerFlow.toLowerCase() == "short") {
              this.logger.info(`${this.log_session_text} ${funcName} case not registered goto page application-form-readonly`);
              await this.router.navigate(["./application-form-readonly"], { relativeTo: this.route })
            } else {
              this.logger.info(`${this.log_session_text} ${funcName} case not registered goto page application-form`);
              await this.router.navigate(["./application-form"], { relativeTo: this.route })
            }
            break;
          }
          case (ResponseStateRegistration.PRE_REGISTERED): {
            this.state = "pre-register";
            this.logger.info(`${this.log_session_text} ${funcName} case pre-registered`);
            if (channel && channel.termsAndCondition && channel.termsAndCondition.action == ActionStatus.ACCEPT && channel.termsAndCondition.status != ResponseStatus.COMPLETED) {
              this.logger.info(`${this.log_session_text} ${funcName} case pre-registered callTermAndCondition start`);
              await this.callTermAndCondition();
            }
            if ((channel.registerFlow.toLowerCase() == "short" && channel.comCode == "insure") || channel.registerFlow.toLowerCase() != "short") {
              this.logger.info(`${this.log_session_text} ${funcName} case pre-registered callconsent start`);
              await this.callConcent(true);
            }
            break;
          }
          case (ResponseStateRegistration.PRE_REGISTERED_PHONE_NOT_MATCH): {
            this.logger.info(`${this.log_session_text} ${funcName} case pre-registered phone not match`);
            this.state = "pre-register-phone-unmatch";
            const id_card = result.data != null ? result.data.id_card : '';
            const identity: Identity = {
              id_card: id_card,
              phone_number: "",
              update_chanel_identity_flag: false,
            }

            this.lineStateAction.sinkIdentity.next(new SetIdentityAction(identity));
            this.logger.info(`${this.log_session_text} ${funcName} case pre-registered phone not match goto page mobile-verify`);
            this.router.navigate(['../mobile-verify'], { relativeTo: this.route, queryParams: { type: 'notmatch' } });
            break;
          }
          case (ResponseStateRegistration.OTHER_ERROR): {
            this.logger.info(`${this.log_session_text} ${funcName} case other error goto page completed status fail`);
            this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail', code: 'E00007' } });
          }
        }
      }
    )
  }

  async callTermAndCondition(identityUcid = null) {
    const funcName = 'callTermAndCondition';
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    const channel = this.lineStateAction.channelStateInfo;
    let body = {
      "comcode": channel.comCode,
      // "channel_identity": channel.channel_identity,
      "electronic_channel": channel.electronic_channel,
      "application_channel_reference": channel.application_channel_reference,
      "app_no": channel.appNo,
      "term_and_condition_id": (channel.termsAndCondition ? channel.termsAndCondition.termConditionId : null),
      "identity_ucid": (identityUcid)
    }
    this.logger.info(`${this.log_session_text} ${funcName} apiCreateOrUpdateTermsAndCondition body:${JSON.stringify(body)}`);
    this.termsAndConditionService.apiCreateOrUpdateTermsAndCondition(body).subscribe(result => {
      this.logger.info(`${this.log_session_text} ${funcName} apiCreateOrUpdateTermsAndCondition response_code:${result?.response_code}`);
      if (result && result.response_code == "40000") {
        console.log("create or update success: ", result);
        channel.termsAndCondition.status = ResponseStatus.COMPLETED;
        // this.lineStateAction.observableChannel.subscribe();
      this.logger.info(`${this.log_session_text} ${funcName} apiCreateOrUpdateTermsAndCondition response_code == 40000 and callConsent start`);
        this.callConcent(true);
      } else {
        this.logger.info(`${this.log_session_text} ${funcName} apiCreateOrUpdateTermsAndCondition response_code fail and goto page completed status fail`);
        this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail', code: 'E00003' } });
      }
    })
  }

  async callConcent(navigate = null) {
    const funcName = 'callConcent';
    const channel = this.lineStateAction.channelStateInfo;
    const cust_type = (this.state == 'pre-register') ? 2 : 1;
    const session_ref = new Date().valueOf()
    let body = {
      "comcode": channel.comCode,
      "cust_type": cust_type,
      "line_channel_id": channel.application_channel_reference,
      // "line_user_id": channel.channel_identity,
      "electronic_channel": channel.electronic_channel,
      "liff_id": channel.liffUrl,
      "session_ref": session_ref,
      "flow_name": channel.registerFlow
    }
    this.logger.info(`${this.log_session_text} ${funcName} apiConcentUrl body:${JSON.stringify(body)}`);
    await this.concentService.apiConcentUrl(body).subscribe(result => {
      this.logger.info(`${this.log_session_text} ${funcName} apiConcentUrl response`);

      if (result && result.data && result.data.token_url) {
        this.logger.info(`${this.log_session_text} ${funcName} apiConcentUrl have token url`);
        this.setSessionStorage(session_ref);
        window.location.href = result.data.token_url;
        return;
        // this.$concentState.next(result)
      } else if (result && result.status) {
        // port page
        this.logger.info(`${this.log_session_text} ${funcName} apiConcentUrl have result.status`);
      } else if (result && result.error && result.response_desc) {
        alert(result.response_desc);
        this.logger.info(`${this.log_session_text} ${funcName} apiConcentUrl have result.response_desc`);
      } else {
        // throw error page or modal
        // alert(tpye + ' concent error');
        this.logger.info(`${this.log_session_text} ${funcName} apiConcentUrl case other`);
      }
      if (navigate) {
        this.logger.info(`${this.log_session_text} ${funcName} apiConcentUrl  goto page completed`);
        this.router.navigate(['../completed'], { relativeTo: this.route });
      }
      console.log('consent result:', result);
    });
  }

  setSessionStorage(sessionRef) {
    const channel = this.lineStateAction.channelStateInfo;
    const identity = this.lineStateAction.identityStateInfo;
    const customer = this.lineStateAction.customerStateInfo;
    let json = {
      "channel": channel,
      "identity": identity,
      "customer": customer,
      "state": this.state
    }
    sessionStorage.setItem(sessionRef, JSON.stringify(json));
  }

}
